// extracted by mini-css-extract-plugin
export default {"UserFormModal":"UserFormModal_UserFormModal__sKAnt"};